import React, { createContext, useState, useContext, useCallback } from 'react';

const BookingContext = createContext();

// Custom hook to use the context
export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

// Provider component
export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    plan: 'daily',
    fullname: '',
    email: '',
    phone: '',
    gender: 'Male',
    package: 'basic',
    startDate: null,
    endDate: null
  });

  // Memoize the update function to prevent unnecessary re-renders
  const updateBookingData = useCallback((key, value) => {
    setBookingData(prev => {
      // Only update if the value actually changed
      if (prev[key] === value) {
        return prev;
      }
      return {
        ...prev,
        [key]: value
      };
    });
  }, []);

  // Memoize the context value
  const contextValue = React.useMemo(() => ({
    bookingData,
    updateBookingData
  }), [bookingData, updateBookingData]);

  return (
    <BookingContext.Provider value={contextValue}>
      {children}
    </BookingContext.Provider>
  );
};